import React from "react";
import {Tag} from "antd";
import styled from 'styled-components';
import BukkuTooltip from "../Tooltip";

const Styled = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${p => (p.alignLeft ? 'flex-start' : 'flex-end')};
  max-width: 100%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  .location-tag {
    margin-right: 0;
    overflow: hidden;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

function LocationTag(props) {
    const { location, color, alignLeft } = props;
    return (
        <Styled alignLeft={!!alignLeft}>
            <BukkuTooltip title={location.name} placement="right">
                <Tag className="location-tag" color={color}>{location.code}</Tag>
            </BukkuTooltip>
        </Styled>
    );
}

export default LocationTag;
